import React from 'react';

export default function CreativeTemplate({ resumeData }) {
	const s = resumeData.sections || {};
	return (
		<div className="p-8 text-sm text-gray-800">
			<div className="bg-gradient-to-r from-primary-600 to-accent-600 text-white -mx-8 -mt-8 px-8 py-6">
				<h1 className="text-3xl font-extrabold">{s.personalInfo?.name || 'Your Name'}</h1>
				<p className="text-xs mt-1 opacity-90">
					{s.personalInfo?.email || ''} {s.personalInfo?.phone ? '• ' + s.personalInfo?.phone : ''}{' '}
					{s.personalInfo?.location ? '• ' + s.personalInfo?.location : ''}
				</p>
			</div>
			<div className="grid grid-cols-3 gap-6 mt-6">
				<div className="col-span-2 space-y-4">
					{s.personalInfo?.summary && (
						<section>
							<h2 className="font-bold text-primary-600">About Me</h2>
							<p className="mt-1">{s.personalInfo.summary}</p>
						</section>
					)}
					{Array.isArray(s.experience) && s.experience.length > 0 && (
						<section>
							<h2 className="font-bold text-primary-600">Experience</h2>
							<div className="mt-2 space-y-3">
								{s.experience.map((e, i) => (
									<div key={i} className="border-l-4 border-primary-600 pl-3">
										<p className="font-semibold">{e.position} • {e.company}</p>
										{e.description && <p className="text-sm">{e.description}</p>}
									</div>
								))}
							</div>
						</section>
					)}
					{Array.isArray(s.projects) && s.projects.length > 0 && (
						<section>
							<h2 className="font-bold text-primary-600">Projects</h2>
							<ul className="list-disc ml-5">
								{s.projects.map((p, i) => (
									<li key={i}>
										<span className="font-medium">{p.title}</span>: {p.description}
									</li>
								))}
							</ul>
						</section>
					)}
				</div>
				<div className="col-span-1 space-y-4">
					{Array.isArray(s.skills) && s.skills.length > 0 && (
						<section>
							<h2 className="font-bold text-primary-600">Skills</h2>
							<div className="mt-2 space-y-2">
								{s.skills.map((cat, i) => (
									<div key={i}>
										<p className="text-xs font-semibold uppercase">{cat.category}</p>
										<div className="h-1 bg-gray-200 rounded overflow-hidden mt-1">
											<div className="h-1 bg-primary-600" style={{ width: '80%' }} />
										</div>
									</div>
								))}
							</div>
						</section>
					)}
					{Array.isArray(s.education) && s.education.length > 0 && (
						<section>
							<h2 className="font-bold text-primary-600">Education</h2>
							<ul className="list-disc ml-5">
								{s.education.map((ed, i) => (
									<li key={i}>
										{ed.degree} • {ed.institution}
									</li>
								))}
							</ul>
						</section>
					)}
				</div>
			</div>
		</div>
	);
}


